"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f110 = void 0;
exports.f110 = {
    "na": [
        "Latn"
    ],
    "naa": [
        "Latn"
    ],
    "nab": [
        "Latn"
    ],
    "nac": [
        "Latn"
    ],
    "nae": [
        "Latn"
    ],
    "naf": [
        "Latn"
    ],
    "nag": [
        "Latn"
    ],
    "naj": [
        "Latn"
    ],
    "nak": [
        "Latn"
    ],
    "nal": [
        "Latn"
    ],
    "nam": [
        "Latn"
    ],
    "nan": [
        "Hans",
        "Bopo",
        "Kana",
        "Latn"
    ],
    "nao": [
        "Zyyy"
    ],
    "nap": [
        "Latn"
    ],
    "naq": [
        "Latn"
    ],
    "nar": [
        "Latn"
    ],
    "nas": [
        "Latn"
    ],
    "nat": [
        "Latn"
    ],
    "naw": [
        "Latn"
    ],
    "nax": [
        "Latn"
    ],
    "nay": [
        "Latn"
    ],
    "naz": [
        "Latn"
    ],
    "nb": [
        "Latn"
    ],
    "nba": [
        "Latn"
    ],
    "nbb": [
        "Latn"
    ],
    "nbc": [
        "Latn"
    ],
    "nbd": [
        "Latn"
    ],
    "nbe": [
        "Latn"
    ],
    "nbg": [
        "Zyyy"
    ],
    "nbh": [
        "Latn"
    ],
    "nbi": [
        "Latn"
    ],
    "nbj": [
        "Latn"
    ],
    "nbk": [
        "Latn"
    ],
    "nbm": [
        "Latn"
    ],
    "nbn": [
        "Latn"
    ],
    "nbo": [
        "Latn"
    ],
    "nbp": [
        "Latn"
    ],
    "nbq": [
        "Latn"
    ],
    "nbr": [
        "Latn"
    ],
    "nbs": [
        "Zxxx"
    ],
    "nbt": [
        "Deva",
        "Latn"
    ],
    "nbu": [
        "Latn"
    ],
    "nbv": [
        "Latn"
    ],
    "nbw": [
        "Latn"
    ],
    "nby": [
        "Latn"
    ],
    "nca": [
        "Latn"
    ],
    "ncb": [
        "Deva",
        "Latn"
    ],
    "ncc": [
        "Latn"
    ],
    "ncd": [
        "Deva"
    ],
    "nce": [
        "Latn"
    ],
    "ncf": [
        "Latn"
    ],
    "ncg": [
        "Latn"
    ],
    "nch": [
        "Latn"
    ],
    "nci": [
        "Latn"
    ],
    "ncj": [
        "Latn"
    ],
    "nck": [
        "Latn"
    ],
    "ncl": [
        "Latn"
    ],
    "ncm": [
        "Latn"
    ],
    "ncn": [
        "Latn"
    ],
    "nco": [
        "Latn"
    ],
    "ncq": [
        "Laoo",
        "Thai"
    ],
    "ncr": [
        "Latn"
    ],
    "ncs": [
        "Zxxx"
    ],
    "nct": [
        "Beng",
        "Latn"
    ],
    "ncu": [
        "Latn"
    ],
    "ncx": [
        "Latn"
    ],
    "ncz": [
        "Zyyy"
    ],
    "nd": [
        "Latn"
    ],
    "nda": [
        "Latn"
    ],
    "ndb": [
        "Latn"
    ],
    "ndc": [
        "Latn"
    ],
    "ndd": [
        "Latn"
    ],
    "ndf": [
        "Cyrl"
    ],
    "ndg": [
        "Latn"
    ],
    "ndh": [
        "Latn"
    ],
    "ndi": [
        "Latn"
    ],
    "ndj": [
        "Latn"
    ],
    "ndk": [
        "Latn"
    ],
    "ndl": [
        "Latn"
    ],
    "ndm": [
        "Latn"
    ],
    "ndn": [
        "Latn"
    ],
    "ndp": [
        "Latn"
    ],
    "ndq": [
        "Latn"
    ],
    "ndr": [
        "Latn"
    ],
    "nds": [
        "Latn"
    ],
    "ndt": [
        "Latn"
    ],
    "ndu": [
        "Latn"
    ],
    "ndv": [
        "Latn"
    ],
    "ndw": [
        "Latn"
    ],
    "ndx": [
        "Latn"
    ],
    "ndy": [
        "Latn"
    ],
    "ndz": [
        "Latn"
    ],
    "ne": [
        "Deva",
        "Brai",
        "Newa"
    ],
    "nea": [
        "Latn"
    ],
    "neb": [
        "Latn"
    ],
    "nec": [
        "Latn"
    ],
    "ned": [
        "Latn"
    ],
    "nee": [
        "Latn"
    ],
    "nef": [
        "Zyyy"
    ],
    "neg": [
        "Cyrl"
    ],
    "neh": [
        "Tibt"
    ],
    "nei": [
        "Xsux"
    ],
    "nej": [
        "Latn"
    ],
    "nek": [
        "Latn"
    ],
    "nem": [
        "Latn"
    ],
    "nen": [
        "Latn"
    ],
    "neo": [
        "Latn"
    ],
    "neq": [
        "Latn"
    ],
    "ner": [
        "Latn"
    ],
    "nes": [
        "Zyyy"
    ],
    "net": [
        "Latn"
    ],
    "neu": [
        "Latn"
    ],
    "nev": [
        "Zyyy"
    ],
    "new": [
        "Deva",
        "Newa",
        "Ranj"
    ],
    "nex": [
        "Latn"
    ],
    "ney": [
        "Latn"
    ],
    "nez": [
        "Latn"
    ],
    "nfa": [
        "Latn"
    ],
    "nfd": [
        "Latn"
    ],
    "nfl": [
        "Latn"
    ],
    "nfr": [
        "Latn"
    ],
    "nfu": [
        "Latn"
    ],
    "ng": [
        "Latn"
    ],
    "nga": [
        "Latn"
    ],
    "ngb": [
        "Latn"
    ],
    "ngc": [
        "Latn"
    ],
    "ngd": [
        "Latn"
    ],
    "nge": [
        "Latn"
    ],
    "ngg": [
        "Latn"
    ],
    "ngh": [
        "Latn"
    ],
    "ngi": [
        "Latn"
    ],
    "ngj": [
        "Latn"
    ],
    "ngk": [
        "Latn"
    ],
    "ngl": [
        "Latn"
    ],
    "ngm": [
        "Latn"
    ],
    "ngn": [
        "Latn"
    ],
    "ngp": [
        "Latn"
    ],
    "ngq": [
        "Latn"
    ],
    "ngr": [
        "Latn"
    ],
    "ngs": [
        "Latn"
    ],
    "ngt": [
        "Laoo"
    ],
    "ngu": [
        "Latn"
    ],
    "ngv": [
        "Latn"
    ],
    "ngw": [
        "Latn"
    ],
    "ngx": [
        "Latn"
    ],
    "ngy": [
        "Latn"
    ],
    "ngz": [
        "Latn"
    ],
    "nha": [
        "Latn"
    ],
    "nhb": [
        "Latn"
    ],
    "nhc": [
        "Latn"
    ],
    "nhd": [
        "Latn"
    ],
    "nhe": [
        "Latn"
    ],
    "nhf": [
        "Latn"
    ],
    "nhg": [
        "Latn"
    ],
    "nhh": [
        "Zyyy"
    ],
    "nhi": [
        "Latn"
    ],
    "nhk": [
        "Latn"
    ],
    "nhm": [
        "Latn"
    ],
    "nhn": [
        "Latn"
    ],
    "nho": [
        "Latn"
    ],
    "nhp": [
        "Latn"
    ],
    "nhq": [
        "Latn"
    ],
    "nhr": [
        "Latn"
    ],
    "nht": [
        "Latn"
    ],
    "nhu": [
        "Latn"
    ],
    "nhv": [
        "Latn"
    ],
    "nhw": [
        "Latn"
    ],
    "nhx": [
        "Latn"
    ],
    "nhy": [
        "Latn"
    ],
    "nhz": [
        "Latn"
    ],
    "nia": [
        "Latn"
    ],
    "nib": [
        "Latn"
    ],
    "nid": [
        "Latn"
    ],
    "nie": [
        "Latn"
    ],
    "nif": [
        "Latn"
    ],
    "nig": [
        "Latn"
    ],
    "nih": [
        "Latn"
    ],
    "nii": [
        "Latn"
    ],
    "nij": [
        "Latn"
    ],
    "nik": [
        "Zyyy"
    ],
    "nil": [
        "Latn"
    ],
    "nim": [
        "Latn"
    ],
    "nin": [
        "Latn"
    ],
    "nio": [
        "Cyrl"
    ],
    "niq": [
        "Latn"
    ],
    "nir": [
        "Latn"
    ],
    "nis": [
        "Latn"
    ],
    "nit": [
        "Telu"
    ],
    "niu": [
        "Latn"
    ],
    "niv": [
        "Cyrl",
        "Latn"
    ],
    "niw": [
        "Latn"
    ],
    "nix": [
        "Latn"
    ],
    "niy": [
        "Latn"
    ],
    "niz": [
        "Latn"
    ],
    "nja": [
        "Latn"
    ],
    "njb": [
        "Latn"
    ],
    "njd": [
        "Latn"
    ],
    "njh": [
        "Latn"
    ],
    "nji": [
        "Latn"
    ],
    "njj": [
        "Latn"
    ],
    "njl": [
        "Latn"
    ],
    "njm": [
        "Latn"
    ],
    "njn": [
        "Latn"
    ],
    "njo": [
        "Latn"
    ],
    "njr": [
        "Latn"
    ],
    "njs": [
        "Latn"
    ],
    "njt": [
        "Latn"
    ],
    "nju": [
        "Latn"
    ],
    "njx": [
        "Latn"
    ],
    "njy": [
        "Latn"
    ],
    "njz": [
        "Beng",
        "Latn"
    ],
    "nka": [
        "Latn"
    ],
    "nkb": [
        "Latn"
    ],
    "nkc": [
        "Latn"
    ],
    "nkd": [
        "Latn"
    ],
    "nke": [
        "Latn"
    ],
    "nkf": [
        "Latn"
    ],
    "nkg": [
        "Latn"
    ],
    "nkh": [
        "Latn"
    ],
    "nki": [
        "Beng",
        "Latn"
    ],
    "nkj": [
        "Latn"
    ],
    "nkk": [
        "Latn"
    ],
    "nkm": [
        "Latn"
    ],
    "nkn": [
        "Latn"
    ],
    "nko": [
        "Latn"
    ],
    "nkp": [
        "Zyyy"
    ],
    "nkq": [
        "Latn"
    ],
    "nkr": [
        "Latn"
    ],
    "nks": [
        "Latn"
    ],
    "nkt": [
        "Latn"
    ],
    "nku": [
        "Latn"
    ],
    "nkv": [
        "Latn"
    ],
    "nkw": [
        "Latn"
    ],
    "nkx": [
        "Latn"
    ],
    "nkz": [
        "Latn"
    ],
    "nl": [
        "Latn",
        "Brai"
    ],
    "nla": [
        "Latn"
    ],
    "nlc": [
        "Latn"
    ],
    "nle": [
        "Latn"
    ],
    "nlg": [
        "Latn"
    ],
    "nli": [
        "Arab"
    ],
    "nlj": [
        "Latn"
    ],
    "nlk": [
        "Latn"
    ],
    "nll": [
        "Zyyy"
    ],
    "nlm": [
        "Arab"
    ],
    "nlo": [
        "Latn"
    ],
    "nlq": [
        "Latn"
    ],
    "nlu": [
        "Latn"
    ],
    "nlv": [
        "Latn"
    ],
    "nlw": [
        "Latn"
    ],
    "nlx": [
        "Deva"
    ],
    "nly": [
        "Latn"
    ],
    "nlz": [
        "Latn"
    ],
    "nma": [
        "Latn"
    ],
    "nmb": [
        "Latn"
    ],
    "nmc": [
        "Latn"
    ],
    "nmd": [
        "Latn"
    ],
    "nme": [
        "Latn"
    ],
    "nmf": [
        "Latn"
    ],
    "nmg": [
        "Latn"
    ],
    "nmh": [
        "Latn"
    ],
    "nmi": [
        "Latn"
    ],
    "nmj": [
        "Latn"
    ],
    "nmk": [
        "Latn"
    ],
    "nml": [
        "Latn"
    ],
    "nmm": [
        "Deva",
        "Tibt"
    ],
    "nmn": [
        "Latn"
    ],
    "nmo": [
        "Beng",
        "Latn"
    ],
    "nmp": [
        "Latn"
    ],
    "nmq": [
        "Latn"
    ],
    "nmr": [
        "Latn"
    ],
    "nms": [
        "Latn"
    ],
    "nmt": [
        "Latn"
    ],
    "nmu": [
        "Latn"
    ],
    "nmv": [
        "Latn"
    ],
    "nmw": [
        "Latn"
    ],
    "nmx": [
        "Latn"
    ],
    "nmy": [
        "Zyyy"
    ],
    "nmz": [
        "Latn"
    ],
    "nn": [
        "Latn"
    ],
    "nna": [
        "Latn"
    ],
    "nnb": [
        "Latn"
    ],
    "nnc": [
        "Latn"
    ],
    "nnd": [
        "Latn"
    ],
    "nne": [
        "Latn"
    ],
    "nnf": [
        "Latn"
    ],
    "nng": [
        "Beng",
        "Latn"
    ],
    "nnh": [
        "Latn"
    ],
    "nni": [
        "Latn"
    ],
    "nnj": [
        "Latn"
    ],
    "nnk": [
        "Latn"
    ],
    "nnl": [
        "Latn"
    ],
    "nnm": [
        "Latn"
    ],
    "nnn": [
        "Latn"
    ],
    "nnp": [
        "Deva",
        "Latn",
        "Wcho"
    ],
    "nnq": [
        "Latn"
    ],
    "nnr": [
        "Latn"
    ],
    "nnt": [
        "Zyyy"
    ],
    "nnu": [
        "Latn"
    ],
    "nnv": [
        "Latn"
    ],
    "nnw": [
        "Latn"
    ],
    "nny": [
        "Latn"
    ],
    "nnz": [
        "Latn"
    ],
    "no": [
        "Latn"
    ],
    "noa": [
        "Latn"
    ],
    "noc": [
        "Latn"
    ],
    "nod": [
        "Lana",
        "Thai"
    ],
    "noe": [
        "Deva"
    ],
    "nof": [
        "Latn"
    ],
    "nog": [
        "Cyrl"
    ],
    "noh": [
        "Latn"
    ],
    "noi": [
        "Deva"
    ],
    "noj": [
        "Latn"
    ],
    "nok": [
        "Latn"
    ],
    "nol": [
        "Zyyy"
    ],
    "nom": [
        "Latn"
    ],
    "non": [
        "Runr"
    ],
    "nop": [
        "Latn"
    ],
    "noq": [
        "Latn"
    ],
    "nos": [
        "Yiii"
    ],
    "not": [
        "Latn"
    ],
    "nou": [
        "Latn"
    ],
    "nov": [
        "Latn"
    ],
    "now": [
        "Latn"
    ],
    "noy": [
        "Latn"
    ],
    "noz": [
        "Zyyy"
    ],
    "npa": [
        "Zyyy"
    ],
    "npb": [
        "Tibt"
    ],
    "npg": [
        "Latn"
    ],
    "nph": [
        "Latn"
    ],
    "npl": [
        "Latn"
    ],
    "npn": [
        "Latn"
    ],
    "npo": [
        "Latn"
    ],
    "nps": [
        "Latn"
    ],
    "npu": [
        "Latn"
    ],
    "npx": [
        "Latn"
    ],
    "npy": [
        "Latn"
    ],
    "nqg": [
        "Latn"
    ],
    "nqk": [
        "Latn"
    ],
    "nql": [
        "Latn"
    ],
    "nqm": [
        "Latn"
    ],
    "nqn": [
        "Latn"
    ],
    "nqo": [
        "Nkoo"
    ],
    "nqq": [
        "Latn"
    ],
    "nqt": [
        "Latn"
    ],
    "nqy": [
        "Latn"
    ],
    "nr": [
        "Latn",
        "Brai"
    ],
    "nra": [
        "Latn"
    ],
    "nrb": [
        "Latn"
    ],
    "nrc": [
        "Zyyy"
    ],
    "nre": [
        "Latn"
    ],
    "nrf": [
        "Latn"
    ],
    "nrg": [
        "Latn"
    ],
    "nri": [
        "Latn"
    ],
    "nrk": [
        "Latn"
    ],
    "nrl": [
        "Latn"
    ],
    "nrm": [
        "Latn"
    ],
    "nrn": [
        "Latn",
        "Runr"
    ],
    "nrp": [
        "Latn"
    ],
    "nrr": [
        "Zyyy"
    ],
    "nrt": [
        "Zyyy"
    ],
    "nru": [
        "Zyyy"
    ],
    "nrx": [
        "Latn"
    ],
    "nrz": [
        "Latn"
    ],
    "nsa": [
        "Latn"
    ],
    "nsb": [
        "Latn"
    ],
    "nsc": [
        "Latn"
    ],
    "nsd": [
        "Yiii"
    ],
    "nse": [
        "Latn"
    ],
    "nsf": [
        "Yiii"
    ],
    "nsg": [
        "Latn"
    ],
    "nsh": [
        "Latn"
    ],
    "nsi": [
        "Zxxx"
    ],
    "nsk": [
        "Cans",
        "Latn"
    ],
    "nsl": [
        "Zxxx"
    ],
    "nsm": [
        "Latn"
    ],
    "nsn": [
        "Latn"
    ],
    "nso": [
        "Latn",
        "Brai"
    ],
    "nsp": [
        "Zxxx"
    ],
    "nsq": [
        "Latn"
    ],
    "nsr": [
        "Zxxx"
    ],
    "nss": [
        "Latn"
    ],
    "nst": [
        "Latn",
        "Tnsa"
    ],
    "nsu": [
        "Latn"
    ],
    "nsv": [
        "Yiii"
    ],
    "nsw": [
        "Latn"
    ],
    "nsx": [
        "Latn"
    ],
    "nsy": [
        "Latn"
    ],
    "nsz": [
        "Latn"
    ],
    "ntd": [
        "Latn"
    ],
    "nte": [
        "Latn"
    ],
    "ntg": [
        "Latn"
    ],
    "nti": [
        "Latn"
    ],
    "ntj": [
        "Latn"
    ],
    "ntk": [
        "Latn"
    ],
    "ntm": [
        "Latn"
    ],
    "nto": [
        "Latn"
    ],
    "ntp": [
        "Latn"
    ],
    "ntr": [
        "Latn"
    ],
    "ntu": [
        "Latn"
    ],
    "ntw": [
        "Zyyy"
    ],
    "ntx": [
        "Latn"
    ],
    "nty": [
        "Yiii"
    ],
    "ntz": [
        "Arab"
    ],
    "nua": [
        "Latn"
    ],
    "nuc": [
        "Latn"
    ],
    "nud": [
        "Latn"
    ],
    "nue": [
        "Latn"
    ],
    "nuf": [
        "Latn"
    ],
    "nug": [
        "Latn"
    ],
    "nuh": [
        "Latn"
    ],
    "nui": [
        "Latn"
    ],
    "nuj": [
        "Latn"
    ],
    "nuk": [
        "Latn"
    ],
    "nul": [
        "Latn"
    ],
    "num": [
        "Latn"
    ],
    "nun": [
        "Latn"
    ],
    "nuo": [
        "Latn"
    ],
    "nup": [
        "Latn",
        "Arab"
    ],
    "nuq": [
        "Latn"
    ],
    "nur": [
        "Latn"
    ],
    "nus": [
        "Latn"
    ],
    "nut": [
        "Latn"
    ],
    "nuu": [
        "Latn"
    ],
    "nuv": [
        "Latn"
    ],
    "nuw": [
        "Latn"
    ],
    "nux": [
        "Latn"
    ],
    "nuy": [
        "Latn"
    ],
    "nuz": [
        "Latn"
    ],
    "nv": [
        "Latn"
    ],
    "nvh": [
        "Latn"
    ],
    "nvm": [
        "Latn"
    ],
    "nvo": [
        "Latn"
    ],
    "nwa": [
        "Zyyy"
    ],
    "nwb": [
        "Latn"
    ],
    "nwc": [
        "Newa",
        "Brah",
        "Deva",
        "Ranj",
        "Sidd"
    ],
    "nwe": [
        "Latn"
    ],
    "nwg": [
        "Latn"
    ],
    "nwi": [
        "Latn"
    ],
    "nwm": [
        "Latn"
    ],
    "nwo": [
        "Latn"
    ],
    "nwr": [
        "Latn"
    ],
    "nwx": [
        "Deva"
    ],
    "nwy": [
        "Zyyy"
    ],
    "nxa": [
        "Latn"
    ],
    "nxd": [
        "Latn"
    ],
    "nxe": [
        "Latn"
    ],
    "nxg": [
        "Latn"
    ],
    "nxi": [
        "Latn"
    ],
    "nxk": [
        "Zyyy"
    ],
    "nxl": [
        "Latn"
    ],
    "nxm": [
        "Tfng"
    ],
    "nxn": [
        "Latn"
    ],
    "nxo": [
        "Latn"
    ],
    "nxq": [
        "Latn",
        "Lisu",
        "Nkgb"
    ],
    "nxr": [
        "Latn"
    ],
    "nxx": [
        "Latn"
    ],
    "ny": [
        "Latn",
        "Brai"
    ],
    "nyb": [
        "Latn"
    ],
    "nyc": [
        "Latn"
    ],
    "nyd": [
        "Latn"
    ],
    "nye": [
        "Latn"
    ],
    "nyf": [
        "Latn"
    ],
    "nyg": [
        "Latn"
    ],
    "nyh": [
        "Latn"
    ],
    "nyi": [
        "Latn"
    ],
    "nyj": [
        "Latn"
    ],
    "nyk": [
        "Latn"
    ],
    "nyl": [
        "Thai"
    ],
    "nym": [
        "Latn"
    ],
    "nyn": [
        "Latn"
    ],
    "nyo": [
        "Latn"
    ],
    "nyp": [
        "Latn"
    ],
    "nyq": [
        "Arab"
    ],
    "nyr": [
        "Latn"
    ],
    "nys": [
        "Latn"
    ],
    "nyt": [
        "Latn"
    ],
    "nyu": [
        "Latn"
    ],
    "nyv": [
        "Latn"
    ],
    "nyw": [
        "Zyyy"
    ],
    "nyx": [
        "Latn"
    ],
    "nyy": [
        "Latn"
    ],
    "nza": [
        "Latn"
    ],
    "nzb": [
        "Latn"
    ],
    "nzd": [
        "Latn"
    ],
    "nzi": [
        "Latn"
    ],
    "nzk": [
        "Latn"
    ],
    "nzm": [
        "Latn"
    ],
    "nzs": [
        "Zxxx"
    ],
    "nzu": [
        "Latn"
    ],
    "nzy": [
        "Latn"
    ],
    "nzz": [
        "Latn"
    ]
};
